import { message } from "antd";
import { isEmpty } from "lodash";
import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/warehouse";

class OutStock {
  @observable isLoading = false;
  @observable tableData = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };
  @observable formData = {};
  @observable planNo = "";
  @observable orderNo = "";
  @observable searchAddress = "";
  @observable searchStatus = "";
  @observable clientName = "";
  @observable supplierName = ""; //供应商名称
  @observable supplierId = ""; //供应商id
  @observable modalVisible = false;
  @observable picking = 0;
  @observable tableOrderNo = "";
  @observable addressArray = [];
  //----------------
  @observable TransferVisible = false; //移库的显示隐藏
  @observable SearchPageInfo = { pageIndex: 1, pageSize: 10 };
  @observable HouseData = [];
  @observable Location = []; //库位的数据
  @observable modalSelectedRowKeys = []; //销售发货页面的row和key
  @observable modalSelectedRows = [];
  @observable allPackageCount = ""; //合格品包数
  @observable allUnitAmount = ""; //合格品总量
  @observable allPackageCountForDefective = ""; //次品包数
  @observable allUnitAmountForDefective = ""; //次品总量
  @observable packageIds = ""; //合格品库存
  @observable packageIdsForDefective = ""; //次品库存
  @observable warehouseId = "";
  @observable clientId = "";
  @observable address = "";
  @observable subVisible = false; //生成配货列表模态框的显示隐藏
  @observable bomList = []; //
  @observable num = 25; //每包自定义,自定义包数25
  @observable DistributionVisible = false;
  @observable driver = "";
  @observable locationNo1 = "";
  @observable locationNo2 = "";
  @observable locationNo3 = ""; //半成品库存库位
  @observable allUnitAmountForSemiFinishedProducts = ""; //半成品总重
  @observable allPackageCountForSemiFinishedProducts = ""; //半成品包数
  @observable title = "";
  @observable packageIdsForSemiFinishedProducts = "";

  //配货列表的数据
  @observable OrderData = [];
  @observable OrderList = [];
  @observable driver1 = "";
  @observable clientId1 = "";
  @observable addressMark = "";
  @observable PrintVisible = false;
  @observable TotalWeight = 0;
  @observable TotalNumber = 0;

  //发货明细列表
  @observable ShipmentData = [];
  @observable planNo1 = "";
  @observable clientId2 = "";
  @observable address1 = "";
  @observable detailedSelectedRows = [];
  @observable detailedSelectedRowKeys = [];
  @observable detailPageInfo = { pageIndex: 1, pageSize: 10 };

  @observable materialId = "";
  @observable materialName = "";
  @observable businessType = "";
  @observable selectedRowKeys = [];
  @observable selectedRows = [];
  @observable pickDetailData = []; //领料明细记录
  @observable PickPageInfo = { pageIndex: 1, pageSize: 10 }; //领料明细记录页码

  @observable stockMaterialData = []; //原材料库存信息列表
  @observable MaterialPageInfo = { pageIndex: 1, pageSize: 10 }; //原材料库存信息列表页码
  // 2新 生产领料20条每页
  // @observable BomListPageInfo = { pageIndex: 1, pageSize: 10 }; //生产领料页面信息列表页码
  @observable BomListPageInfo = { pageIndex: 1, pageSize: 20 }; //生产领料页面信息列表页码
  @observable materialSelectedRowKeys = [];
  @observable materialSelectedRows = [];

  @observable planId = "";
  @observable orderId = "";
  @observable status = 0;
  @observable printSelectedRowKeys = [];
  @observable printSelectedRows = [];

  @observable printModalVis = false; //打印页面展示
  @observable printData = [];
  @observable printSumData = "";
  @observable printSumWeight = "";
  @observable color = "";
  @observable clientData = []; // 获取的客户数据
  @observable supplierData = []; // 获取的供应商数据
  @observable mergePrintingVis = false;

  @observable manualVisible = false;

  @observable masterData = []; // 获取的物料数据
  @observable searchMaterialId = "";
  @observable searchStartDate = "";
  @observable searchEndDate = "";
  @observable printTableData = []; //出库单打印信息

  @observable ShipmentDetails = []; //销售发货列表

  @observable rawMaterialTableData = [];
  @observable rawMaterialPageInfo = { pageIndex: 1, pageSize: 10 };

  @observable printPlanNo = "";
  @observable startTimeForDeadline = ""; //生产领料开始时间
  @observable endTimeForDeadline = ""; //生产领料结束时间

  @observable searchStartDate = "";
  @observable searchEndDate = "";
  @observable PickingQuantity = 0;
  @observable planAmount = 0;
  @observable pickAmount = 0;
  @observable startOutTime = "";
  @observable endOutTime = "";

  //根据物料id获取库存信息列表
  @action.bound async getRawMaterialStockDetailList(params) {
    this.isLoading = true;
    try {
      params.status = "1,2";
      let res = await services.getRequest(
        services.requestUrl.getRawMaterialStockDetailList,
        params,
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        console.log("res", res);
        this.rawMaterialTableData = res.data.data.items;
        this.rawMaterialPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async getMaster(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getMaster,
        params,
      );
      if (isDataExist(res)) {
        this.masterData = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async getClient(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getClient,
        params,
      );
      if (isDataExist(res)) {
        this.clientData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action async getSupplier(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getSupplier,
        params,
      );
      if (isDataExist(res)) {
        this.supplierData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //出库管理-生产领料-页面数据
  @action.bound async getBomList(params) {
    this.isLoading = true;
    const url = services.requestUrl.getBomList;
    this.planAmount = 0;
    this.pickAmount = 0;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.BomListPageInfo,
      });
      if (isDataExist(res)) {
        res.data.data.items.map((item) => {
          if (item.status != 99) {
            this.planAmount += Number(item.planCount) || 0;
            this.pickAmount += Number(item.pickingNum) || 0;
          }
          item.remark1 = (item.plan && item.plan.remark) || "";
          return item;
        });
        this.isLoading = false;
        this.tableData = res.data.data.items;
        this.BomListPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getSaveDistribution(params) {
    console.log(params, "params");
    const url = services.requestUrl.saveOrUpdateBatchOrderDistribution;
    try {
      let res = await services.putRequest(url, params);
      if (isDataExist(res)) {
        message.success("提交成功");
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getListOutPlan(params) {
    this.isLoading = true;
    const url = services.requestUrl.getListOutPlan;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.SearchPageInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items.map((item) => {
          item.locationNo =
            (item.warehouseDo && item.warehouseDo.locationNo) || "";
          item.fullName = (item.supplier && item.supplier.fullName) || "";
          item.fullName1 = (item.client && item.client.fullName) || "";
          item.orderNo = (item.orderDo && item.orderDo.orderNo) || "";
          item.planNo = (item.productPlan && item.productPlan.planNo) || "";
          item.name = (item.material && item.material.name) || "";
          item.color = (item.orderDo && item.orderDo.color) || "";
          item.planCount =
            (item.productPlan && item.productPlan.planCount) || "";
          item.unit = (item.material && item.material.unit) || "";
          item.remark1 = (item.orderDo && item.orderDo.remark) || "";
          item.remark2 = (item.orderDo && item.orderDo.remark2) || "";
          item.warehouseId = (item.warehouseDo && item.warehouseDo.id) || "";
          item.supplierId = (item.supplier && item.supplier.id) || "";
          item.clientId = (item.client && item.client.id) || "";
          item.orderId = (item.orderDo && item.orderDo.id) || "";
          item.planId = (item.productPlan && item.productPlan.id) || "";
          item.materialId = (item.material && item.material.id) || "";
          item.address2 =
            item.address1 || item.address2 || item.address3
              ? item.address2 || ""
              : item.orderDo && item.orderDo.address2;
          item.address3 =
            item.address1 || item.address2 || item.address3
              ? item.address3 || ""
              : item.orderDo && item.orderDo.address3;
          item.address1 =
            item.address1 || (item.orderDo && item.orderDo.address1);
          item.locationNo1 =
            (item.warehouseDoForSemiFinishedProducts &&
              item.warehouseDoForSemiFinishedProducts.locationNo) ||
            "";
          item.PackageNumberOne =
            item.address1Amount &&
            Number(item.address1Amount) / Number(this.num);
          item.PackageNumberTwo =
            item.address2Amount &&
            Number(item.address2Amount) / Number(this.num);
          item.PackageNumberThree =
            item.address3Amount &&
            Number(item.address3Amount) / Number(this.num);
          return item;
        });
        res.data.data.items = res.data.data.items.filter((item, index) => {
          return (
            item.allUnitAmount &&
            Number(item.allUnitAmount) -
              ((item.allOutedAmount && Number(item.allOutedAmount)) || 0) >
              0
          );
        });
        console.log("7777", res.data.data);
        this.ShipmentDetails = res.data.data.items;
        this.SearchPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //销售发货-移库-仓库类型
  @action.bound async getWarehouseType(params) {
    const url = services.requestUrl.wareHouseList;
    try {
      let res = await services.getRequest(url, params);
      if (isDataExist(res)) {
        this.HouseData = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //销售发货-移库-库位数据
  @action.bound async getWarehouse(params) {
    const url = services.requestUrl.WarehouseType;
    try {
      let res = await services.getRequest(url, params);
      if (isDataExist(res)) {
        this.Location = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //销售发货-移库-确定的接口
  @action.bound async getSaveHouse(params) {
    const url = services.requestUrl.EditByBatch;
    try {
      let res = await services.getRequest(url, params);
      if (isDataExist(res)) {
        message.success("移库成功");
      }
    } catch (error) {
      console.log(error);
    }
  }
  //查询获取表格数据
  @action.bound async getData(type, params) {
    this.isLoading = true;
    //1生产领料  2销出
    const url =
      type === 1
        ? services.requestUrl.getBomList
        : services.requestUrl.listOutOrder;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        if (res.data.data.length > 0) {
          // console.log('出错了。。。。')
          // this.planId = res.data.data[0].planId;
        } else {
          this.planId = "";
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action.bound async getOrderOutStock(params) {
    this.isLoading = true;
    const url = services.requestUrl.orderOutStock;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items.map((item) => {
          item.unit = (item.material && item.material.unit) || "";
          item.remark = (item.order && item.order.remark) || "";
          item.fullName = item.client.fullName || "";
          return item;
        });
        this.OrderData = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getDetail(params) {
    this.isLoading = true;
    const url = services.requestUrl.listDistributionDetail;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items.map((item) => {
          item.fullName = (item.client && item.client.fullName) || "";
          item.unit = (item.material && item.material.unit) || "";
          // item.remark=item.order&&item.order.remark||''
          item.locationNo = (item.warehouse && item.warehouse.locationNo) || "";
          item.orderNo = (item.order && item.order.orderNo) || "";
          item.planNo = (item.plan && item.plan.planNo) || "";
          item.name = (item.material && item.material.name) || "";
          item.color = (item.order && item.order.color) || "";
          item.remark1 = (item.order && item.order.remark) || "";
          item.remark2 = (item.order && item.order.remark2) || "";
          item.planCount = (item.plan && item.plan.planCount) || "";
          item.fullName1 = (item.supplier && item.supplier.fullName) || "";
          item.remarks = "";
          this.TotalWeight += Number(item.amount) || 0;
          this.TotalNumber += Number(item.packageCount) || 0;
          return item;
        });
        this.OrderList = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getSalesOutList(params) {
    this.isLoading = true;
    //销出
    const url = services.requestUrl.listOutOrder;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.PageInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        if (res.data.data.items.length > 0) {
          this.planId = res.data.data.items[0].planId;
        } else {
          this.planId = "";
        }
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //发货明细列表的数据
  @action.bound async getShipmentDetails(params) {
    this.isLoading = true;
    const url = services.requestUrl.ShipmentDetails;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.detailPageInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items.map((item) => {
          item.orderNo = (item.order && item.order.orderNo) || "";
          item.planNo = (item.plan && item.plan.planNo) || "";
          item.name = (item.material && item.material.name) || "";
          item.color = (item.order && item.order.color) || "";
          item.remark1 = (item.order && item.order.remark) || "";
          item.remark2 = (item.order && item.order.remark2) || "";
          item.unit = (item.material && item.material.unit) || "";
          item.fullName = (item.supplier && item.supplier.fullName) || "";
          item.fullName1 = (item.client && item.client.fullName) || "";
          item.createTime1 = (item.order && item.order.createTime) || "";
          item.locationNo = (item.warehouse && item.warehouse.locationNo) || "";
          item.planCount = (item.plan && item.plan.planCount) || "";
          return item;
        });
        this.ShipmentData = res.data.data.items;
        this.detailPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //获取领料明细表格数据
  @action.bound async gePickDetailData(type, params) {
    this.isLoading = true;
    //1领料明细  2发货明细  3原材料出库明细
    const url =
      type === 1
        ? services.requestUrl.producePickingList
        : type === 2
          ? services.requestUrl.orderStockList
          : services.requestUrl.rawMaterialsOutStockRecordList;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.PickPageInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.pickDetailData = res.data.data.items;
        this.PickPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //根据ids获取出库单打印信息
  @action.bound async getSalesOutPrintData(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.getSalesOutPrintData,
        params,
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.printTableData = res.data.data;
        let sumAmount = 0;
        let printSumWeight = 0;
        let array = res.data.data;
        array.map((item) => {
          sumAmount += item.totalAmount;
          printSumWeight += item.weightAmount;
        });
        this.printSumData = sumAmount;
        this.printSumWeight = printSumWeight;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // [1,2,3]
  //  "ids:1,2,3"

  //根据物料id获取库存信息列表
  @action.bound async getStockMaterialData(type, params) {
    this.isLoading = true;
    //1库存信息列表  2成品库存信息
    const url =
      type === 1
        ? services.requestUrl.rawMaterialStockListAll //------
        : services.requestUrl.finishedProductStockListAll;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        this.stockMaterialData = res.data.data;
        // this.MaterialPageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //保存信息
  @action.bound async saveData(type, params) {
    this.isLoading = true;
    //1原材料入库列表 2:成品入库  3原材料出库保存
    const url =
      type === 1
        ? services.requestUrl.saveProduceSaveByMerge
        : type === 2
          ? services.requestUrl.saveOrderStock
          : services.requestUrl.saveRawMaterialsOutStockRecord;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        if (res.data.code == 0) {
          message.success(`${res.data.data}`);
        } else {
          message.error("领料失败");
        }
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound showStockTable(visible) {
    this.modalVisible = visible;
  }

  @action.bound showModalTable(visible) {
    this.TransferVisible = visible; //移库的显示隐藏
  }

  @action.bound showPrintTable(visible) {
    this.printModalVis = visible;
  }

  //打开/关闭模态框
  @action modalChange = (type, record) => {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  };
  // 清除数据
  @action clearData() {
    this.isLoading = false;
    this.tableData = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.planNo = "";
    this.orderNo = "";
    this.searchAddress = "";
    this.searchStatus = "";
    this.clientName = "";
    this.supplierName = "";
    this.planId = "";
    this.orderId = "";
    this.tableOrderNo = "";
    this.addressArray = [];
    this.materialId = "";
    this.modalVisible = false;
    this.formData = {};
    this.pickDetailData = [];
    this.PickPageInfo = { pageIndex: 1, pageSize: 10 };
    this.stockMaterialData = [];
    this.MaterialPageInfo = { pageIndex: 1, pageSize: 10 };
    this.printModalVis = false; //打印页面展示
    this.printData = [];
    this.printSumData = "";
    this.printSumWeight = "";
    this.clientData = [];
    this.supplierData = [];
    this.masterData = []; // 获取的物料数据

    this.searchMaterialId = "";
    this.searchStartDate = "";
    this.searchEndDate = "";
    this.picking = "";
    this.manualVisible = false;
    this.color = ""; //颜色的查询条件
    this.printTableData = []; //出库单打印信息

    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.printSelectedRowKeys = [];
    this.printSelectedRows = [];
    this.materialSelectedRowKeys = [];
    this.materialSelectedRows = [];
    this.rawMaterialTableData = [];
    this.rawMaterialPageInfo = { pageIndex: 1, pageSize: 10 };
    this.startTimeForDeadline = "";
    this.endTimeForDeadline = "";
    this.printPlanNo = "";

    this.searchStartDate = "";
    this.searchEndDate = "";
    this.businessType = "";
    this.supplierId = "";
    this.TransferVisible = false; //移库的显示隐藏
    this.ShipmentDetails = [];
    this.SearchPageInfo = { pageIndex: 1, pageSize: 10 };
    this.HouseData = [];
    this.Location = []; //库位的数据
    this.modalSelectedRowKeys = [];
    this.modalSelectedRows = [];
    this.allPackageCount = ""; //合格品包数
    this.allUnitAmount = ""; //合格品总量
    this.allPackageCountForDefective = ""; //次品包数
    this.allUnitAmountForDefective = ""; //次品总量
    this.packageIds = ""; //合格品库存
    this.packageIdsForDefective = ""; //次品库存
    this.warehouseId = ""; //库存Id
    this.clientId = ""; //销售发货的客户Id
    this.address = ""; // 销售发货地址的查询
    this.subVisible = false; // 生成配货列表模态框的显示隐藏
    this.bomList = [];
    this.num = 25;
    this.driver = "";
    //配货列表的数据
    this.OrderData = [];
    this.DistributionVisible = false;
    this.OrderList = [];
    this.driver1 = "";
    this.clientId1 = "";
    this.addressMark = "";
    this.PrintVisible = false;
    this.TotalWeight = 0;
    this.TotalNumber = 0;
    this.mergePrintingVis = false;
    //发货明细列表
    this.ShipmentData = [];
    this.planNo1 = "";
    this.clientId2 = "";
    this.address1 = "";
    this.detailedSelectedRows = [];
    this.detailedSelectedRowKeys = [];
    this.detailPageInfo = { pageIndex: 1, pageSize: 10 };
    this.locationNo1 = ""; //移库的合格品库存
    this.locationNo2 = ""; //移库的次品库存
    this.title = "";
    this.planAmount = 0;
    this.pickAmount = 0;
    this.startOutTime = "";
    this.endOutTime = "";
    this.locationNo3 = ""; //半成品库存库位
    this.allUnitAmountForSemiFinishedProducts = ""; //半成品总重
    this.allPackageCountForSemiFinishedProducts = ""; //半成品包数
    this.packageIdsForSemiFinishedProducts = "";
    this.materialName = "";
  }

  @action clearDialogData() {
    this.materialSelectedRowKeys = [];
    this.materialSelectedRows = [];
    this.materialId = "";
    this.planNo = "";
  }
}

let OutStockStore = new OutStock();
export default OutStockStore;
